import styled from "styled-components"

export const Container = styled.div`
max-width: 100%;
padding: 0 20px;
width: 1000px;
margin: 0 auto;

`
